import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  selectedCertificateId: null,
  activeCertificateRow: null,
  isReloadGrid: null,
  isReloadDetails: null,
  isLoadingCertificateList: false,
}

export const certificateListSlice = createSlice({
  name: 'certificateList',
  initialState,
  reducers: {
    updateSelectedCertificateId: (state, action) => {
      state.selectedCertificateId = action.payload
    },
    reloadCertificateList: (state, action) => {
      state.isReloadGrid = action.payload
    },
    reloadCertificateDetails: (state, action) => {
      state.isReloadDetails = action.payload
    },
    updateIsLoadingCertificateList: (state, action) => {
      state.isLoadingCertificateList = action.payload
    },
    updateActiveCertificateRow: (state, action) => {
      state.activeCertificateRow = action.payload
    },
  },
})

export const {
  updateSelectedCertificateId,
  reloadCertificateList,
  reloadCertificateDetails,
  updateIsLoadingCertificateList,
  updateActiveCertificateRow,
} = certificateListSlice.actions

export const selectCertificateList = state => state.certificateList

export const selectIsLoadingCertificateList = state =>
  state.certificateList.isLoadingCertificateList

export const selectActiveCertificateRow = state => state.certificateList.activeCertificateRow

export default certificateListSlice.reducer
